import { ColorPicker, Form, Input, Select } from 'antd';
import { collect } from 'collect.js';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PolygraphyProductImageType, PolygraphyProductUrlType } from '../../../../../services/exports/Constants';
import ImagePicker from '../../../../form/general/ImagePicker';

export default function FlyerFourForm({
  data,
  images,
  polygraphyProductUrlTypeOptions,
  onChange,
  onImageChange,
  renderFeedbackLabel,
  className,
}) {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'Components:Marketing:Polygraphy:Products:Templates:Flyer:FlyerFourForm',
  });

  return (
    <Form layout="vertical" className={className}>
      {renderFeedbackLabel}
      <Form.Item label={t('form.header.label')}>
        <Input.TextArea
          value={data.header}
          onChange={(e) => onChange('header', e.target.value)}
          rows={2}
          placeholder={t('form.header.placeholder')}
        />
      </Form.Item>
      <Form.Item label={t('form.sub_header.label')}>
        <Input.TextArea
          value={data.sub_header}
          onChange={(e) => onChange('sub_header', e.target.value)}
          rows={2}
          placeholder={t('form.sub_header.placeholder')}
        />
      </Form.Item>
      <Form.Item label={t('form.description.label')}>
        <Input.TextArea
          value={data.description}
          onChange={(e) => onChange('description', e.target.value)}
          rows={2}
          placeholder={t('form.description.placeholder')}
        />
      </Form.Item>
      <Form.Item label={t('form.qr_code_header.label')}>
        <Input.TextArea
          value={data.qr_code_header}
          onChange={(e) => onChange('qr_code_header', e.target.value)}
          rows={2}
          placeholder={t('form.qr_code_header.placeholder')}
        />
      </Form.Item>
      <Form.Item label={t('form.qr_code_description.label')}>
        <Input.TextArea
          value={data.qr_code_description}
          onChange={(e) => onChange('qr_code_description', e.target.value)}
          rows={2}
          placeholder={t('form.qr_code_description.placeholder')}
        />
      </Form.Item>
      <Form.Item label={t('form.footer.label')}>
        <Input.TextArea
          value={data.footer}
          onChange={(e) => onChange('footer', e.target.value)}
          rows={2}
          placeholder={t('form.footer.placeholder')}
        />
      </Form.Item>
      <Form.Item label={t('form.url_type.label')}>
        <Select
          value={data.url_type}
          options={polygraphyProductUrlTypeOptions}
          className="w-full"
          onChange={(value) => onChange('url_type', value)}
          placeholder={t('form.url_type.placeholder')}
        />
        {data?.url_type === PolygraphyProductUrlType.Custom && (
          <Input
            className="mt-xs"
            placeholder={t('form.url.placeholder')}
            value={data.url}
            defaultValue={data.url}
            onChange={(e) => onChange('url', e.target.value)}
          />
        )}
      </Form.Item>
      <Form.Item label={t('form.primary_color.label')}>
        <ColorPicker
          showText
          value={data.primary_color}
          onChange={(color) => onChange('primary_color', color.toHexString())}
        />
      </Form.Item>
      <Form.Item label={t('form.background_color.label')}>
        <ColorPicker
          showText
          value={data.background_color}
          onChange={(color) => onChange('background_color', color.toHexString())}
        />
      </Form.Item>
      <Form.Item label={t('form.logo.label')}>
        <ImagePicker
          images={[collect(images).firstWhere('type', PolygraphyProductImageType.Logo)?.file_url]}
          onChange={(value) => onImageChange(PolygraphyProductImageType.Logo, collect(value).first())}
          format="image/png,image/jpeg"
          withCropper
        />
      </Form.Item>
    </Form>
  );
}
